// extracted by mini-css-extract-plugin
export default {"privacy_policy_body":"style__privacy_policy_body__vtWP7","privacy_policy_description":"style__privacy_policy_description__u7eep"};